const MOCK_SPECS_POOL = [
    { ano: '2019', kms: '87000', combustivel: 'Diesel', caixa_velocidades: 'Manual', cilindrada: '1461', locacao: '5' },
    { ano: '2021', kms: '42000', combustivel: 'Gasolina', caixa_velocidades: 'Automática', cilindrada: '999', locacao: '5' },
    { ano: '2018', kms: '112000', combustivel: 'Diesel', caixa_velocidades: 'Manual', cilindrada: '1598', locacao: '5' },
    { ano: '2020', kms: '65000', combustivel: 'Híbrido', caixa_velocidades: 'Automática', cilindrada: '1798', locacao: '5' },
];

const hashString = (value = '') => {
    let hash = 0;
    for (let i = 0; i < value.length; i += 1) {
        hash = (hash << 5) - hash + value.charCodeAt(i);
        hash |= 0;
    }
    return Math.abs(hash);
};

export const resolveCarId = (car, index = 0) => {
    const rawId = String(car?.id ?? '').trim();
    if (rawId) return rawId;

    const shortcode = String(car?.instagramShortcode ?? '').trim();
    if (shortcode) return shortcode;

    const title = String(car?.titulo ?? '').trim();
    if (title) return `viatura-${hashString(title)}`;

    return `viatura-${index + 1}`;
};

export const findCarByRouteId = (cars = [], routeId) => {
    const id = String(routeId ?? '').trim();
    if (!id) return null;

    return cars.find((car, index) => {
        const resolved = resolveCarId(car, index);
        return (
            resolved === id ||
            String(car.id ?? '').trim() === id ||
            String(car.instagramShortcode ?? '').trim() === id
        );
    });
};

export const getCarDetailPath = (car, index = 0) => `/automoveis/${encodeURIComponent(resolveCarId(car, index))}`;

const hasValue = (value) => value && value !== '—' && value !== '0' && value !== 0;

export const enrichCarDetails = (car, index = 0) => {
    if (!car) return null;

    const mock = MOCK_SPECS_POOL[hashString(resolveCarId(car, index)) % MOCK_SPECS_POOL.length];

    return {
        ...car,
        id: resolveCarId(car, index),
        ano: hasValue(car.ano) ? car.ano : mock.ano,
        kms: hasValue(car.kms) ? car.kms : mock.kms,
        combustivel: hasValue(car.combustivel) ? car.combustivel : mock.combustivel,
        caixa_velocidades: hasValue(car.caixa_velocidades) ? car.caixa_velocidades : mock.caixa_velocidades,
        cilindrada: hasValue(car.cilindrada) ? car.cilindrada : mock.cilindrada,
        locacao: hasValue(car.locacao) ? car.locacao : mock.locacao,
        garantia_meses: car.garantia_meses || '12',
        segunda_chave: car.segunda_chave ?? true,
        informacoes_extra:
            car.informacoes_extra ||
            'Viatura inspecionada e preparada para entrega. Equipamento de série em bom estado. Documentação em dia. Possibilidade de financiamento e retoma — contacte-nos para mais detalhes.',
    };
};
